import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useCommunitySubEvent } from './communityHooks';

/**
 * Returns an event
 * @param {Number} eventId      Event Id
 * @returns {object}
 */
export const useEvent = (eventId) => {
    const { eventId: defaultEventId } = useParams(),
        selector = useCallback((state) => state.events[eventId || defaultEventId]?.event, [eventId, defaultEventId]);
    return useSelector(selector);
};

/**
 * Returns a subevent and it's parent community
 * @param {Number} eventId      Event Id
 * @returns [{object}, {object}]        [community, event]
 */
export const useSubEvent = (eventId) => {
    const parents = useSelector((state) => state.events.parents),
        parentId = parents[eventId],
        parent = useEvent(parentId),
        subEvent = useCommunitySubEvent(parentId, eventId);
    return [parent, subEvent];
};

export const useLoadedEvents = () => useSelector((state) => state.events.loadedEvents);

export const useEventHasMap = (eventId) => {
    const event = useEvent(eventId);
    return !!event.map_url || !!event.exhibitors_map_url;
};

